import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const heroImages = [
  "/images/hero_images/yat1.webp",
  "/images/hero_images/yat2.webp",
  "/images/hero_images/yat3.webp",
];

const HeroImageSlider: React.FC = () => {
  const { t } = useTranslation();

  const heroTexts = [
    <span className="font-playfair" key="hero-1">
      {t("hero.mavi")} <span className="text-blue-400">{t("hero.maviliğinde")}</span>, {t("hero.yolArkadaşı")}
    </span>,
    <span className="font-playfair" key="hero-2">
      {t("hero.hayal")}
    </span>,
    <span className="font-playfair" key="hero-3">
      {t("hero.tasarim")}
    </span>,
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative md:-mt-14">
      {/* Üst kağıt efekti */}
      <img
        src="/images/transbg-top.png"
        alt="Top Torn Paper"
        className="w-full absolute top-0 left-0 z-0 pointer-events-none"
        loading="eager"
      />

      <div className="relative w-full h-[500px] sm:h-[700px] lg:h-[950px] rounded-xl overflow-hidden">
        {/* Arka Plan Görseli */}
        <img
          src={heroImages[currentImage]}
          alt="Haber görseli"
          className="w-full h-full object-cover"
          loading="eager"
        />

        {/* Siyah Filtre */}
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>

        {/* Yazı Alanı */}
        <div className="absolute inset-0 flex flex-col justify-center items-center px-4 text-center">
          <h2 className="text-white text-2xl sm:text-5xl lg:text-6xl font-bold mb-4 drop-shadow-md font-righteous">
            AYVALIK MARİN
          </h2>
          <p className="text-white text-sm sm:text-xl lg:text-3xl drop-shadow-sm font-playfair max-w-3xl">
            {heroTexts[currentImage]}
          </p>
        </div>
      </div>

      {/* Alt kağıt efekti */}
      <img
        src="/images/transbg-bottom.png"
        alt="Bottom Torn Paper"
        className="w-full absolute bottom-0 left-0 z-0 pointer-events-none"
        loading="eager"
      />
    </div>
  );
};

export default HeroImageSlider;
